import React from "react";
import { MdBusinessCenter, MdTune } from 'react-icons/md';
import { RiRobotLine, RiCloudLine, RiBook2Line, RiShieldLine } from 'react-icons/ri';
import { FaRegMoneyBillAlt } from 'react-icons/fa';

export default function MainSection8() {
  const whyChooseData = [
    {
      icon: <MdBusinessCenter />,
      title: "Enterprise-Ready AI",
      description:
        "Secure, scalable, and designed for seamless API-driven integration into enterprise ecosystems.",
    },
    {
      icon: <RiRobotLine />,
      title: "Autonomous AI Agents",
      description:
        "Deploy AI-powered agents that execute complex tasks, automate workflows, and enhance productivity.",
    },
    {
      icon: <MdTune />,
      title: "Fine-Tuned for Industry-Specific Needs ",
      description:
        "Pre-trained and custom AI models optimized for healthcare, finance, retail, and technology use cases.",
    },
    {
      icon: <RiCloudLine />,
      title: "Multi-Cloud & On-Premise Flexibility ",
      description:
        "Deploy AI workloads on AWS, Azure, GCP, or private cloud environments with full governance.",
    },
    {
      icon: <RiBook2Line />,
      title: "Advanced RAG (Retrieval-Augmented Generation)",
      description:
        "Elevate AI reasoning with real-time, context-aware retrieval from enterprise knowledge bases.",
    },
    {
      icon: <FaRegMoneyBillAlt />,
      title: "Cost-Optimized Token-Based Usage ",
      description:
        "Predictable pricing with scalable AI inference tailored to enterprise demands.",
    },
    {
      icon: <RiShieldLine />,
      title: "Enterprise-Grade Security & Compliance",
      description:
        "End-to-end encryption and adherence to GDPR, HIPAA, SOC2, and enterprise data governance standards.",
    },
  ];
  return (
    <div className="px-4 py-4 my-auto md:px-12 md:py-12 bg-[#F7F7FC]">
      <div className="flex flex-col mb-6 pb-12 justify-center lg:justify-center lg:flex-row md:mb-8">
        <h2 className="max-w-lg font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
          <span className="inline-block mb-1 sm:mb-4">Why Choose AeroGenix GPT?</span>
          <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
        </h2>
      </div>
      <div className="flex flex-wrap justify-center gap-10">
        {whyChooseData.map((item, index) => (
          <div
            key={index}
            className="card w-[400px] border border-primary shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
          >
            <div className="card-body items-center text-center">
              <div className="text-4xl text-primary mb-4">{item.icon}</div>
              <h3 className="card-title text-xl mb-2">{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
